import { RESET_APP_STATE } from '../types/appTypes';

import { resetTalentsState } from './talentsActions';

// eslint-disable-next-line import/prefer-default-export
export const resetAppState = () => (dispatch) => {
  dispatch({ type: RESET_APP_STATE });
  dispatch(resetTalentsState());
};
